import { faro, getWebInstrumentations, initializeFaro, TransportItem } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import configuration from '@config';

const URL_QUERY_PATTERN = /(https?:\/\/[^\s?#"'<>]*)[?#][^\s"'<>]*/gi;

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const urlPrefixOf = (value: string | undefined): string | null => {
  if (!value) return null;
  try {
    const { origin, pathname } = new URL(value, window.location.origin);
    const path = pathname.replace(/\/+$/, '');
    return path ? `${origin}${path}` : null;
  } catch {
    return null;
  }
};

const withoutUrlQueries = (value: unknown): unknown => {
  if (typeof value === 'string') return value.replace(URL_QUERY_PATTERN, '$1');
  if (Array.isArray(value)) return value.map(withoutUrlQueries);
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([key, entry]) => [key, withoutUrlQueries(entry)]));
  }
  return value;
};

export function initFaro(): void {
  const url = import.meta.env.VITE_FARO_URL as string | undefined;
  if (!url || faro.config) return;
  const prefixes = [urlPrefixOf(configuration.GATEWAY_API_HOST), `${window.location.origin}/api`].filter(
    (prefix): prefix is string => prefix !== null,
  );
  initializeFaro({
    url,
    app: {
      name: 'clarke-sales-web-new',
      namespace: 'clarke',
      version: __APP_VERSION__,
      environment: (import.meta.env.VITE_APP_ENV as string | undefined) ?? 'beta',
    },
    instrumentations: [
      ...getWebInstrumentations({ captureConsole: false }),
      new TracingInstrumentation({
        instrumentationOptions: {
          propagateTraceHeaderCorsUrls: prefixes.map((prefix) => new RegExp(`^${escapeRegExp(prefix)}(?:[/?#]|$)`)),
        },
      }),
    ],
    beforeSend: (item) => withoutUrlQueries(item) as TransportItem,
  });
}

export function setFaroUser(id: string | undefined): void {
  if (!faro.config) return;
  if (id) faro.api.setUser({ id });
  else faro.api.resetUser();
}
